import React from 'react';
import T from 'prop-types';

import GELFooter from '@icare/react-kit/lib/components/Footer';
import {sitePaths} from '~/paths';
import {MAIN_SITE_ROOT, FOOTER_LINKS} from '~/config';
import withAuth from '@icare/auth-okta/lib/withAuth';
import injectContent from '@icare/sitecore-content/lib/injectContent';

@injectContent(['smlFacebook', 'smlYoutube', 'smlTwitter', 'smlInstagram', 'smlLinkedIn'])
@withAuth
export default class Footer extends React.PureComponent {
	static propTypes = {
		auth: T.object.isRequired,
		navLinks: T.array,
		content: T.object.isRequired,
	};

	static defaultProps = {
		navLinks: [
			{title: 'Contact icare', link: FOOTER_LINKS.contactUs, target: '_blank'},
			{title: 'Terms and Condition', link: FOOTER_LINKS.termsAndCondition, target: '_blank'},
			{title: 'Accessibility', link: sitePaths.accessibilityPage, target: ''},
			{title: 'Privacy', link: FOOTER_LINKS.privacy, target: '_blank'},
		],
	};

	render() {
		const {auth, navLinks, content} = this.props;
		const {smlFacebook, smlTwitter, smlYoutube, smlInstagram, smlLinkedIn} = content;
		const socialMediaLinks = [
			...(smlLinkedIn.c1
				? [
						{
							href: smlLinkedIn.c1,
							title: 'Like us on linkedin',
							imageSource: require('@icare/core/statics/icons-social/icon-linkedin-colour.svg'),
							imageAlt: 'icare on LinkedIn',
						},
				  ]
				: []),

			...(smlYoutube.c1
				? [
						{
							href: smlYoutube.c1,
							title: 'Like us on youtube',
							imageSource: require('@icare/core/statics/icons-social/icon-youtube-colour.svg'),
							imageAlt: 'icare on Youtube',
						},
				  ]
				: []),

			...(smlFacebook.c1
				? [
						{
							href: smlFacebook.c1,
							title: 'Like us on facebook',
							imageSource: require('@icare/core/statics/icons-social/icon-facebook-colour.svg'),
							imageAlt: 'icare on Facebook',
						},
				  ]
				: []),

			...(smlTwitter.c1
				? [
						{
							href: smlTwitter.c1,
							title: 'Like us on twitter',
							imageSource: require('@icare/core/statics/icons-social/icon-twitter-colour.svg'),
							imageAlt: 'icare on Twitter',
						},
				  ]
				: []),

			...(smlInstagram.c1
				? [
						{
							href: smlInstagram.c1,
							title: 'Like us on instagram',
							imageSource: require('@icare/core/statics/icons-social/icon-instagram-colour.svg'),
							imageAlt: 'icare on Instagram',
						},
				  ]
				: []),
		];

		if (auth.isAuthenticated && navLinks.length) {
			navLinks[0].link = `${MAIN_SITE_ROOT}${sitePaths.contactUsPage}`;
		}

		return (
			<GELFooter
				logoUrl={require('@icare/core/statics/icons-social/icare-logo-white.svg')}
				navLinks={navLinks}
				socialMediaLinks={socialMediaLinks}
			/>
		);
	}
}
